import React, { useContext, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { AptorUserTable } from './AptorUserTable';
import { CreateAptorUserForm } from './CreateAptorUserForm';
import { UpdateAptorUserForm } from './UpdateAptorUserForm';
import { Routes, Route, Navigate } from 'react-router-dom';
import { UserContext, AdminFeature, AccessLevel } from '../../../../Context/UserContext/UserContext';
import { ModuleContext } from '../../../../Context/ModuleContext/ModuleContext';

export const AptorUsers = () => {
  const { hasAccessToFeature } = useContext(UserContext);
  const { formatMessage } = useIntl();
  const { setHeader } = useContext(ModuleContext);

  useEffect(() => {
    setHeader(formatMessage({ id: 'admin.users.header', defaultMessage: 'Users' }));
  }, [setHeader, formatMessage]);

  return (
    <Routes>
      <Route path="/" element={<AptorUserTable />} />
      {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path="create" element={<CreateAptorUserForm />} />
      )}
      {hasAccessToFeature(AdminFeature.Administrate, AccessLevel.Manage) && (
        <Route path=":id" element={<UpdateAptorUserForm />} />
      )}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};
